import {
  setupCompanyRequestSchema,
  setupCompanyResponseSchema,
  setupStatusResponseSchema,
  type SetupCompanyRequest,
} from '@gb-ticket/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';
import { publicBrandQueryKey } from '@/platform/brand/use-public-brand';

export const setupStatusQueryKey = ['setup', 'status'] as const;

export function useSetupStatus() {
  return useQuery({
    queryKey: setupStatusQueryKey,
    queryFn: () => apiFetch('/setup/status', setupStatusResponseSchema),
    retry: false,
    staleTime: 30_000,
  });
}

export function useSetupCompany() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: SetupCompanyRequest) =>
      apiFetch('/setup/company', setupCompanyResponseSchema, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(setupCompanyRequestSchema.parse(body)),
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: setupStatusQueryKey });
      await queryClient.invalidateQueries({ queryKey: publicBrandQueryKey });
    },
  });
}
